import ApiService from "@/core/services/api.service";

const state = {
  form: {
    name: "",
    description: "",
    time_in: "",
    cut_off_time_in: "",
    time_out: "",
    cut_off_time_out: "",
  },
  isBusy: false,
};

const actions = {
  async saveEmployeeGroup() {
    console.log("Submitting,", state.form);
    state.isBusy = true;
    ApiService.setHeader();
    return ApiService.post("group/record/register", state.form)
      .then((response) => {
        console.log("Registered device", response);
      })
      .finally(() => {
        state.isBusy = false;
      });
  },
};

const mutations = {};

export default {
  state,
  actions,
  mutations,
};
